<div class="field" 
  [ngClass]="{
    'field--light': theme === 'light',
    'field--dark': theme === 'dark',
    'field--inline': display === 'inline',
    'field--compact': isCompact
  }">
  
  <label class="field__label text-uppercase text-10" *ngIf="label">
    {{ label }}
  </label>
  
  <div class="field__input mt-1">
    <ng-content></ng-content>

    <div class="field__help text-dim text-11">
      <ng-content select="[form-field-help]"></ng-content>
    </div>
  </div>
</div>